import React from 'react';
import styled from 'styled-components';

import { Link } from 'react-router-dom';

import { colors, layout } from 'Constants';

import { Container, Footnote, Anchor } from 'Components/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FacebookIcon from './images/footer_fb.svg';
import TwitterIcon from './images/footer_twitter.svg';
import YoutubeIcon from './images/footer_yt.svg';

import { ApiStore } from 'Store';
import { Subscribe } from 'laco-react';
import CODES from 'Root/libs/analytics/CodeDef';

const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  background-color: #081f65;//${colors.accent};
  padding: 32px;
  color: ${colors.textOnAccent};
  text-align: center;
`;

// TODO: Implement API values
export default () => (
  <Subscribe to={[ApiStore]}>
    {state => (
      <FooterContainer>
        <Container
          seperation="24px"
          alignItems
          column
          style={{ maxWidth: layout.maxWidth, width: '100%' }}
        >
          <Container seperation="36px" style={{ alignSelf: 'center' }}>
      
     
      
          </Container>
          <p>
            <Anchor code={CODES.FOOT_ANTHEM_LINK} to={state.brandInfo?.webLink} color={colors.textOnAccent}>
              {state.brandInfo?.name}
            </Anchor>{' '}
            |{' '}
            <Anchor
              code={CODES.FOOT_PP_LINK}
              to={state.brandInfo?.privacyPolicy}
              color={colors.textOnAccent}
            >
              PRIVACY POLICY
            </Anchor>{' '}
            |{' '}
            <Anchor code={CODES.FOOT_LEGAL_LINK} to={state.brandInfo?.legal} color={colors.textOnAccent}>
              LEGAL
            </Anchor>
          </p>
          <Footnote>{state.brandInfo?.legalText}</Footnote>
        </Container>
      </FooterContainer>
    )}
  </Subscribe>
);
